import { render, staticRenderFns } from "./oficio-de-aprobacion.vue?vue&type=template&id=2e2701b8&lang=html&"
import script from "./oficio-de-aprobacion.vue?vue&type=script&lang=js&"
export * from "./oficio-de-aprobacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports